import { createAction } from '@reduxjs/toolkit';
import { IAddress } from '../../customer/customerTypes';

export const setPaymentFormAddress = createAction<IAddress>('@paymentForm/setPaymentFormAddress');
export const setPaymentFormAddressErrors = createAction<Omit<IAddress, "line2">>('@paymentForm/setPaymentFormAddressErrors');
export const setPaymentFormCardholderName = createAction<string>('@paymentForm/setPaymentFormCardholderName');
export const setPaymentFormCardholderNameError = createAction<string>('@paymentForm/setPaymentFormCardholderNameError');
